import React from "react";

const Contact = () => {
  return (
    <div className="contact-page flex flex-col p-2 my-2 overflow-auto max-w-7xl mx-auto w-full space-y-2">
      <h1 className="text-2xl font-semibold text-center">Contact Page</h1>
      <p className="text-lg font-semibold text-center">This is Contact Page</p>
    </div>
  );
};

export default Contact;
